































import { Component, Vue } from 'vue-property-decorator'
import NoData from '@/components/NoData'
import { getToolMainListRequest } from '@/api/msgEnterprise'

@Component({
  components: {
    NoData,
  },
})
export default class Login extends Vue {
        private actionNum:Number=1000
  private renderContent = (value: any, row: any, index: any) => {
    const obj = {
      children: value,
      attrs: {},
    }
    return obj
  };
  private data: any = [];
  private dataT: any = [];
  private columns: any = [
    {
      title: '等级',
      dataIndex: 'level',
      width: '10%',
      align: 'center',
      customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.level,
           style: {
            'background-color': '#fcfcfc',
          },
          attrs: { rowSpan: 0,colSpan :1 }
        }
        if (index == 0) {
          obj.attrs.rowSpan = row.n
        }
        if(row.n=='sum'){
            obj.attrs.rowSpan = 3
            obj.attrs.colSpan = 2
        }
        if(row.n=='sum1'){
            // obj.attrs.rowSpan = 1
            obj.attrs.colSpan = 2
        }
        return obj
      },
    },
    {
      title: '序号',
      width: '10%',
      dataIndex: 'key',
    customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.key,
          attrs: { colSpan :1 }
        }
        if(row.n=='sum'){
            obj.attrs.colSpan = 0
            
        }
        if(row.n=='sum1'){
            // obj.attrs.rowSpan = 1
            obj.attrs.colSpan = 0
        }
        return obj
      },
    },
    {
      title: '能源种类及限定值',
      dataIndex: 'energyName',
      width: '15%',
        customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.energyName,
           style: {
            'background-color': '',
          },
        }
        if(row.n=='sum'){
            obj.style['background-color']='#fcfcfc'
        }
        return obj
      },
    },
    {
      title: '计量器具类别',
      dataIndex: 'measuringType',
      width: '15%',
              customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.measuringType,
           style: {
            'background-color': '',
          },
        }
        if(row.n=='sum'){
            obj.style['background-color']='#fcfcfc'
        }
        return obj
      },
    },
    {
      title: '运行状态',
      dataIndex: 'runningStatus',
      width: '15%',
              customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.runningStatus,
           style: {
            'background-color': '',
          },
        }
        if(row.n=='sum'){
            obj.style['background-color']='#fcfcfc'
        }
        return obj
      },
    },
    {
      title: '安装使用地点',
      dataIndex: 'installAddress',
      width: '15%',
              customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.installAddress,
           style: {
            'background-color': '',
          },
        }
        if(row.n=='sum'){
            obj.style['background-color']='#fcfcfc'
        }
        return obj
      },
    },
    {
      title: '是否在检定周期内',
      dataIndex: 'checkFlag',
      width: '15%',
              customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: row.checkFlag,
           style: {
            'background-color': '',
          },
        }
        if(row.n=='sum'){
            obj.style['background-color']='#fcfcfc'
        }
        return obj
      },
    },
    // {
    //   title: '操作',
    //    width: '100px',
    //   scopedSlots: { customRender: 'action' },
    //   customCell: (record: any, rowIndex: any) => {
    //     if (rowIndex == 0) {
    //         return {
    //             style: {display: record.key === this.actionNum ? 'none' : undefined},
    //             attrs: {
    //                 rowSpan: this.actionNum,
    //             }
    //         }
    //     }else{
    //         return {
    //             style: {display: 'none'},
    //             attrs: {
    //                 rowSpan: 0,
    //             }
    //         }
    //     }
    //   }
    // }
  ];
  private columnsT: any = [
    {
      title: '小计',
      width: '20%',
      align: 'center',
      customRender: (value: any, row: any, index: any) => {
        const obj = {
          children: value,
          attrs: { colSpan: 0 },
        }
        if (index == 0) {
          obj.attrs.colSpan = 1
        }
        return obj
      },
    },
    {
      title: '应配数量（台）',
      dataIndex: 'shouldNum',
      width: '16%',
      align: 'center',
    },
    {
      title: '实配数量（台）',
      dataIndex: 'realNum',
      width: '16%',
      align: 'center',
    },
    {
      title: '配备率(%)',
      dataIndex: 'provideRate',
      width: '16%',
      align: 'center',
    },
    {
      title: '完好率(%)',
      dataIndex: 'goodRate',
      width: '16%',
      align: 'center',
    },
    {
      title: '检定率(%)',
      dataIndex: 'checkRate',
      width: '16%',
      align: 'center',
    },
  ];
  async getToolMainList(params: any) {
    const { status, data } = await getToolMainListRequest({ id: params })
    const arr = data.map((element: any, index: any) => {
      const newArr = new Array()
      element.child.map((ele: any, i: any) => {
        ele['level'] = element.level
        ele['key'] = i + 1
        ele['n'] = element.child.length
      })
      
      element.child.push({
            'level': '小计',
             'key': '0',
             'id': '0',
            'energyName': '应配数量(台)',
            'measuringType': '实配数量(台)',
            'runningStatus': '配备率(%)',
            'installAddress': '完好率(%)',
            'checkFlag': '检定率(%)',
            'n':'sum',
        },{
            'level': '小计',
            'key': '01',
            'id': '01',
            'energyName': element.shouldNum?element.shouldNum:0,
            'measuringType': element.realNum?element.realNum:0,
            'runningStatus': element.provideRate?element.provideRate:0,
            'installAddress': element.goodRate?element.provideRate:0,
            'checkFlag': element.checkRate?element.checkRate:0,
            'n':'sum1',
        })
      if(element.child.length==2){
          element.child.unshift({level:element.level,id:'1'})
          }
      newArr.push(element)
      return newArr
    })
    this.data = arr
  }

  mounted() {
    if (this.$route.query.code) {
      this.getToolMainList(this.$route.query.code)
    }
  }
}
